import { observer } from 'mobx-react-lite';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import autoPaymentStore, { AutoPaymentStore } from 'src/stores/AutoPaymentStore';
import DetailInfoElement from '../../components/DetailInfoItem';
import Toolbar from '../../components/Toolbar';
import { formatDate, formatMoney } from '../../utils';
import UserInfoService from '../../utils/UserInfoService';
import { PolicyDetail } from '../../models/PolicyDetail';
import { FORMAT_DATE_YYYY_MM_DD } from '../../constants';

interface DetailAutoPaymentObserverProps {
  store: AutoPaymentStore
}

const DetailAutoPaymentObserver = observer(({store}: DetailAutoPaymentObserverProps) => {
  const [t] = useTranslation();
  const history = useHistory();

  const [detail, setDetail] = useState<PolicyDetail | null>(null);

  useEffect(() => {
      store.getPeriodicPolicy(
        {
          policyNumber: history.location.state['policyNumber']
        }
      ).then((response: any) => {
        setDetail(response);
      });
  }, [history.location.state, store]);

  const _handleClose = () => {
    history.push('/');
  };

  const _handleBack = () => {
    history.goBack();
  };

  return (
    <div className="screen-container ct-view bg-background fix-scroll">
      <Toolbar
        title={t('detail_auto_payment_info')}
        showClose={true}
        onClose={_handleClose}
        onBack={_handleBack}
      />

      <div className="show-detail p-3">
        <div className={'show-detail-top border border-line border-radius-bottom mb-4 p-4 bg-white rounded'}>
          <div className="bg-surface pt-2 pb-3 mb-4  border-b border-line">
            <div className="text-base font-bold text-onSurface">
              {t("detail_info")}
            </div>
          </div>
          <DetailInfoElement title={t('policy_number')} content={detail?.policyNum} />
          <DetailInfoElement title={t('main_product_name')} content={detail?.productName} />
          <DetailInfoElement title={t('policy_start_date_1')} content={formatDate(detail?.policyEffDate, FORMAT_DATE_YYYY_MM_DD)} />
          <DetailInfoElement title={t('pay_frequency')} content={detail?.payFreqText} />
          <DetailInfoElement title={t('fee_frequency')} content={
            detail?.periodicPremium && detail?.currency ?
              formatMoney(detail.periodicPremium)
              + ' '
              + detail?.currency
              : null
          } />
        </div>

      </div>
    </div>
  );
});

const DetailAutoPayment = () => <DetailAutoPaymentObserver store={autoPaymentStore} />;
export default DetailAutoPayment;